var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIntercomClose = function SvgIntercomClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M24 44c11.05 0 20-8.95 20-20S35.05 4 24 4 4 12.95 4 24s8.95 20 20 20z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    style: {
      fill: "#fff"
    },
    d: "M24 22.94l3.97-3.97 1.06 1.06L25.06 24l3.97 3.97-1.06 1.06L24 25.06l-3.97 3.97-1.06-1.06L22.94 24l-3.97-3.97 1.06-1.06"
  })));
};
export default SvgIntercomClose;